module.exports = __webpack_public_path__ + "static/media/octopusCard_horizontal.3679cd92.png";